
import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'sonner';
import { useMutation } from '@apollo/client';
import { Loader2 } from 'lucide-react';
import { jwtDecode } from 'jwt-decode';

import { JWT_AUTH } from '@/integrations/apollo/operations';

const JwtAuth = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const [jwtAuth] = useMutation(JWT_AUTH);

  useEffect(() => {
    const processJwt = async () => {
      try {
        const token = searchParams.get("tk");

        if (!token) {
          toast.error("Authentication failed: No token provided");
          return;
        }

        // Call the GraphQL mutation directly using Apollo Client
        const response = await jwtAuth({
          variables: { jwt: token }
        });

        if (response.errors) {
          console.error("Authentication error:", response.errors);
          toast.error("Failed to process authentication token");
          return;
        }

        const userData = response.data?.jwtAuth;

        if (userData && userData.id && userData.email) {
          // Save user data to localStorage
          localStorage.setItem("user", JSON.stringify({
            user: userData
          }));

          toast.success("Successfully authenticated");

          // Redirect to dashboard
          setTimeout(() => {
            const decoded = jwtDecode(token);
            const redirectPath = decoded['redirect_path'] ? decoded['redirect_path'] : '/dashboard';

            navigate(redirectPath);
          }, 1000);
        } else {
          toast.error("Authentication failed: No user data received");
        }
      } catch (err) {
        console.error("Unexpected error during authentication:", err);
        toast.error("An unexpected error occurred");
        toast.error("Authentication failed");
      }
    };

    processJwt();
  }, [searchParams, navigate, jwtAuth]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-4">
      <div className="mx-auto bg-background rounded-xl shadow-lg overflow-hidden px-8 py-8 relative">
        <Loader2 className="animate-spin" />
      </div>
    </div>
  );
};

export default JwtAuth;
